import React from "react";
import { Route } from "react-router-dom";
import AccessControl from "../../../components/utilities/Class/AccessControl";
import settlementSales from "../../../containers/modules/mutation/settlement-sales";
import MutationDeposit from "../../../containers/modules/mutation/mutation-deposit";

export default function MutationDepositRoute(props) {
  const { authUser } = props;
  return (
    <Route
      path="/mutation-deposit"
      index
      element={
        <AccessControl
          name={"Mutation Deposit List"}
          auth={authUser}
          component={() => (
            <MutationDeposit authUser={authUser}></MutationDeposit>
          )}
        />
      }
    />
  );
}
